import { Grid } from "@mui/material";
import { RouteComponentProps } from "@reach/router";
import CardHESP from "../../components/CardHESP/CardHESP";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import TLAManageInstallContextsForm from "../../components/TLA/TLAManageInstallContextsForm";

interface Props extends RouteComponentProps {
    organizationId?: string;
    datacenterId?: string;
}

export default function TLADatacenterInstallContextCreate({ datacenterId }: Props) {
    return (
        <Grid container spacing={{ xs: 5, md: 6 }} justifyContent="center">
            <Grid item xs={12}>
                <SectionTitle title={`Create an install context for ${datacenterId}`} align="left" showBottomBorder />
                <CardHESP>
                    <TLAManageInstallContextsForm
                        datacenterId={datacenterId!}
                        values={{
                            command: "",
                            description: "",
                            disableVaultSSH: true,
                            labels: [],
                            name: "",
                            nodeLabels: [],
                            privateCIDR: "",
                            privateId: "",
                            securityToken: "",
                            upgradeDocker: true,
                        }}
                    />
                </CardHESP>
            </Grid>
        </Grid>
    );
}
